<router-outlet></router-outlet>
<spinner></spinner>